import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
//import { AcceptAccountComponent } from './localuser/accept-account/accept-account.component';
import { AdminlacourLicenceComponent } from './admin/adminlacourlicence/adminlacourLicence.component';
import { AdminlacourCommandComponent } from './admin/adminlacourcommand/adminlacourCommand.component';
import { ConnectionComponent } from './connection/connection.component';
import { HomeComponent } from './home/home.component';
//import { PasswordforgottenComponent } from './localuser/passwordforgotten/passwordforgotten.component';
//import { ResetPwdComponent } from './localuser/reset-pwd/reset-pwd.component';
import { ActionMaterielComponent } from './Support/action-materiel/action-materiel.component';
import { CatalogueComponent } from './Support/catalogue/catalogue.component';
import { HistoryComponent } from './Support/history/history.component';
import { HomeSupportComponent } from './Support/home-support/home-support.component';
import { PanierComponent } from './Support/panier/panier.component';
import { UserClientFormComponentV2 } from './Support/user-client-formV2/user-client-formV2.component';
// Auth Guard
import { AuthGuardService as AuthGuard } from './tools/auth-guard.service';
import { ProductsListComponent } from './admin/products-list/products-list.component';
import { GlobalColorbookComponent } from './ColorBook/globalColorbook/globalColorbook.component';
import { GlobalColorwebtechComponent } from './ColorWebTech/globalColorwebtech/globalColorwebtech.component';
import { GlobalMixitCloudComponent } from './ColorWebTechMixitCloud/globalMixitCloud/globalMixitCloud.component';
import { MajComponent } from './Support/maj/maj.component';
import { RentingComponent } from './Support/renting/renting.component';
import { RenaultmailComponent } from './admin/renaultmail/renaultmail.component';
import { ReferentaccountsComponent } from './renaultstaff/referentaccounts/referentaccounts.component';
import { HiddenReferences } from './renaultstaff/hiddenReferences/hiddenReferences.component';
import { LocalaccounthistoryComponent } from './admin/localaccounthistory/localaccounthistory.component';
import { ScaleAutoActivationComponent } from './Support/scale-auto-activation/scale-auto-activation.component';
import { ActivationlistComponent } from './renaultstaff/activationlist/activationlist.component';
import { AdminlacourRentingComponent } from './admin/adminlacourrenting/adminlacourRenting.component';
import { AdminhomeComponent } from './admin/adminhome/adminhome.component';
import { RentinglistComponent } from './renaultstaff/rentinglist/rentinglist.component';
import { DroitsComponent } from './renaultstaff/droits/droits.component';
import { ImportFileComponent } from './admin/importFile/importFile.component';
import { BreakdownFileComponent } from './monitoring/breakdownfile/breakdownfile.component';
import { HomeAssistanceComponent } from './Support/assistance/home-assistance/home-assistance.component';
import { ContactAssistanceComponent } from './Support/assistance/contact-assistance/contact-assistance.component';
import { TchatAssistanceComponent } from './Support/assistance/tchat-assistance/tchat-assistance.component';
import { PlanningComponent } from './Support/planning/planning.component';
import { PlanningHistoryComponent } from './Support/planning/planning-history/planning-history.component';
import { PlanningGestionComponent } from './Support/planning/planning-gestion/planning-gestion.component';

import { ColormatchingComponent } from './Contretypage/colormatching/colormatching.component';
import { ResponseColorMatchingComponent } from './Contretypage/response-color-matching/response-color-matching.component';
import { HistoriqueColorMatchingComponent } from './Contretypage/historique-color-matching/historique-color-matching.component';
import { ManageColorUserV2 } from './localuser/manageColorUserV2/manageColorUserV2.component';
//import { ManageColorUser } from './localuser/manageColorUser/manageColorUser.component';
import { HistoColorUser } from './localuser/histoColorUser/histoColorUser.component';
import { MonitoringInterneComponent } from './admin/monitoringInterne/monitoringInterne.component';
import { AdminlacourColorUserComponent } from './admin/adminlacour-color-user/adminlacour-color-user.component';
import { ScaleHistoryComponent } from './admin/scale-history/scale-history.component';

import { DocumentComponent } from './Documents/document/document.component';

import { StatisticsComponent } from './statistics/statistics/statistics.component';
import { CloudComponent } from './cloud/cloud/cloud.component';
import { CloudMissingComponent } from './cloud/missing/missing.component';


const routes: Routes = [
    { path: 'panier', component: PanierComponent },
    { path: 'panier/:cartCode', component: PanierComponent },
    { path: 'home', component: HomeComponent/*, canActivate: [AuthGuard]*/ },
    { path: 'home/auto/:login/:pwd', component: HomeComponent }, //, canActivate: [AuthGuard] },
    //{ path: 'home/token/:token', component: HomeComponent }, //, canActivate: [AuthGuard] },
    { path: 'home/:paymentAccepted/:billingID', component: HomeComponent, canActivate: [AuthGuard] },
    { path: 'colorbook', component: GlobalColorbookComponent },
    { path: 'iwl/colorbook', component: GlobalColorbookComponent },
    { path: 'colorbook/:login/:pwd', component: GlobalColorbookComponent },
    { path: 'colorwebtech', component: GlobalColorwebtechComponent, canActivate: [AuthGuard] },
    { path: 'equinox', component: GlobalMixitCloudComponent, canActivate: [AuthGuard] },
    //{ path: 'password', component: PasswordforgottenComponent },
    //{ path: 'resetpwd/:id', component: ResetPwdComponent },
    //{ path: 'acceptaccount/:token', component: AcceptAccountComponent },
    { path: 'manageaccount', component: ManageColorUserV2, canActivate: [AuthGuard] },
    { path: 'historyaccount', component: HistoColorUser, canActivate: [AuthGuard] },
    { path: 'activation_scale/:code', component: ScaleAutoActivationComponent, canActivate: [AuthGuard] },
    { path: 'userClientForm', component: UserClientFormComponentV2, canActivate: [AuthGuard] },
    { path: 'userClientForm/:code', component: UserClientFormComponentV2, canActivate: [AuthGuard] },
    { path: 'userClientForm/Client/:idClient', component: UserClientFormComponentV2, canActivate: [AuthGuard] },

    { path: 'login', component: ConnectionComponent },
    { path: 'login/token/:token', component: ConnectionComponent }, //, canActivate: [AuthGuard] },

    { path: 'activlist', component: ActivationlistComponent, canActivate: [AuthGuard] },
    { path: 'support', component: HomeSupportComponent, canActivate: [AuthGuard] },
    { path: 'actionmateriel', component: ActionMaterielComponent, canActivate: [AuthGuard] },
    { path: 'adminlacourLicence', component: AdminlacourLicenceComponent, canActivate: [AuthGuard] },
    { path: 'adminlacourLicence/:tab', component: AdminlacourLicenceComponent },
    { path: 'adminlacourCommande', component: AdminlacourCommandComponent, canActivate: [AuthGuard] },
    { path: 'adminlacourCommande/:tab', component: AdminlacourCommandComponent },
    { path: 'listproducts', component: ProductsListComponent, canActivate: [AuthGuard] },
    { path: 'panier', component: PanierComponent, canActivate: [AuthGuard] },
    { path: 'catalogue', component: CatalogueComponent, canActivate: [AuthGuard] },
    { path: 'catalogue/:code', component: CatalogueComponent },
    { path: 'maj', component: MajComponent },
    { path: 'history', component: HistoryComponent, canActivate: [AuthGuard] },
    { path: 'renting', component: RentingComponent, canActivate: [AuthGuard] },
    { path: 'rentinglist', component: RentinglistComponent, canActivate: [AuthGuard] },
    { path: 'renaultmail', component: RenaultmailComponent, canActivate: [AuthGuard] },
    { path: 'referentaccounts', component: ReferentaccountsComponent, canActivate: [AuthGuard] },
    { path: 'hiddenReferences', component: HiddenReferences, canActivate: [AuthGuard] },
    { path: 'localaccounthistory', component: LocalaccounthistoryComponent, canActivate: [AuthGuard] },
    { path: 'adminlacourRenting', component: AdminlacourRentingComponent, canActivate: [AuthGuard] },
    { path: 'adminhome', component: AdminhomeComponent, canActivate: [AuthGuard] },
    { path: 'breakdownfile', component: BreakdownFileComponent, canActivate: [AuthGuard] },
    { path: 'importFile', component: ImportFileComponent, canActivate: [AuthGuard] },
    { path: 'contretypage/request', component: ColormatchingComponent, canActivate: [AuthGuard] },
    { path: 'contretypage/historic', component: HistoriqueColorMatchingComponent, canActivate: [AuthGuard] },
    { path: 'contretypage/response', component: ResponseColorMatchingComponent, canActivate: [AuthGuard] },
    { path: 'assistance', component: HomeAssistanceComponent, canActivate: [AuthGuard] },
    { path: 'contact', component: ContactAssistanceComponent, canActivate: [AuthGuard] },
    { path: 'tchat', component: TchatAssistanceComponent, canActivate: [AuthGuard] },
    { path: 'planning', component: PlanningComponent, canActivate: [AuthGuard] },
    { path: 'planningHistorique', component: PlanningHistoryComponent, canActivate: [AuthGuard] },
    { path: 'planningGestion', component: PlanningGestionComponent, canActivate: [AuthGuard] },
    { path: 'monitoringInterne', component: MonitoringInterneComponent, canActivate: [AuthGuard] },
    { path: 'adminlacourColorUser', component: AdminlacourColorUserComponent, canActivate: [AuthGuard] },
    { path: 'droits', component: DroitsComponent, canActivate: [AuthGuard] },
    { path: 'scaleHistory', component: ScaleHistoryComponent, canActivate: [AuthGuard] },
    { path: 'document', component: DocumentComponent },
    //{ path: 'colorbook', component: GlobalColorbookComponent },

    { path: 'statistics', component: StatisticsComponent, canActivate: [AuthGuard] },
    { path: 'cloud', component: CloudComponent, canActivate: [AuthGuard] },
    { path: 'cloud/missing', component: CloudMissingComponent },

    { path: '**', component: ConnectionComponent }
    //{ path: '**', component: HomeComponent }
];

@NgModule({
    imports: [RouterModule.forRoot(routes, {}), TranslateModule],
    exports: [RouterModule, TranslateModule]
})
export class AppRoutingModule { }
